'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _index = require('../../../common/cards/index');

var _index2 = _interopRequireDefault(_index);

var _Card = require('./Card');

var _Card2 = _interopRequireDefault(_Card);

var _CardContainer = require('./CardContainer');

var _CardContainer2 = _interopRequireDefault(_CardContainer);

var _browser = require('../../utils/services/browser');

var _toolbarConstants = require('../../workspace/toolbar/toolbarConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    return (0, _index2.default)({
        containerComponent: _CardContainer2.default,
        presentationalComponent: _Card2.default,
        tools: [_toolbarConstants.TOOLS.RICH_TEXT, _toolbarConstants.TOOLS.COLOR, _extends({}, _toolbarConstants.TOOLS.CAPTION, { name: 'Description' })],
        tooltip: _browser.isApple ? '⌃⌘N' : 'Ctrl+Alt+N'
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/card/index.js
// module id = 1961
// module chunks = 0